import React from 'react';

import { Grid, Box, Stack, Skeleton } from '@mui/material';

import { COLOR } from '../../../helpers/colors';

const textBox = (
  <Skeleton
    variant="text"
    color={COLOR.PH}
    style={{
      width: '25%',
    }}
    animation="wave"
  />
);
const imagePlaceholder = (height, width) => (
  <Skeleton
    variant="rectangular"
    color={COLOR.PH}
    style={{
      width,
      height,
    }}
    animation="wave"
  />
);
const ListPlaceholder = () => (
  <Box
    sx={{
      p: 2,
      mt: 2,
      border: `1px solid ${COLOR.borderColor}`,
      borderRadius: 1,
    }}
  >
    {textBox}

    <Stack direction="row" justifyContent="space-between">
      {textBox}
      {textBox}
    </Stack>
    <Grid container item direction="row" justifyContent="flex-start">
      <Grid item xs={12} sm={12} md={2} sx={{ mt: { xs: 2, md: 2 }, mb: { xs: 2, md: 0 } }}>
        {imagePlaceholder(100, 100)}
      </Grid>
      <Grid item xs={12} sm={12} md={8} alignSelf="center">
        {textBox}
        {textBox}
        {textBox}
      </Grid>
      <Grid item xs={12} sm={12} md={2} container flexDirection="row" justifyContent="flex-end">
        {textBox}
      </Grid>
    </Grid>
    <Stack direction="row" justifyContent="flex-end">
      {textBox}
    </Stack>

    <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
      {imagePlaceholder(20, 20)}
      {imagePlaceholder(20, 20)}
    </Stack>
  </Box>
);

export default ListPlaceholder;
